import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Box, Typography } from '@mui/material';

import type { CMS1500FormData } from '../ClaimCMS1500Form';
import { formStyles } from '../ClaimCMS1500Form.styles';
import { ClaimTextField } from '../fields';
import { StateSelect } from '../StateSelect';

export const Box32_ServiceFacility: React.FC = () => {
  const { control } = useFormContext<CMS1500FormData>();
  return (
    <>
      <Typography variant="caption">32. SERVICE FACILITY LOCATION INFORMATION</Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        <Controller
          name="serviceFacility.name"
          control={control}
          render={({ field, fieldState }) => (
            <ClaimTextField field={field} fieldState={fieldState} size="small" placeholder="Facility Name" fullWidth />
          )}
        />
        <Controller
          name="serviceFacility.line1"
          control={control}
          render={({ field, fieldState }) => (
            <ClaimTextField field={field} fieldState={fieldState} size="small" placeholder="Address Line 1" fullWidth />
          )}
        />
        <Controller
          name="serviceFacility.line2"
          control={control}
          render={({ field, fieldState }) => (
            <ClaimTextField
              field={field}
              fieldState={fieldState}
              size="small"
              placeholder="Address Line 2 (Optional)"
              fullWidth
            />
          )}
        />
        <Box sx={{ display: "flex", gap: 1 }}>
          <Controller
            name="serviceFacility.city"
            control={control}
            render={({ field, fieldState }) => (
              <ClaimTextField
                field={field}
                fieldState={fieldState}
                size="small"
                placeholder="City"
                fullWidth
                sx={{ flex: 1 }}
              />
            )}
          />
          <Controller
            name="serviceFacility.state"
            control={control}
            render={({ field, fieldState }) => (
              <StateSelect {...field} size="small" placeholder="State" error={!!fieldState.error} helperText={fieldState.error?.message} />
            )}
          />
          <Controller
            name="serviceFacility.zip"
            control={control}
            render={({ field, fieldState }) => (
              <ClaimTextField
                field={field}
                fieldState={fieldState}
                size="small"
                placeholder="ZIP"
                sx={{
                  width: '100px',
                  minWidth: '100px',
                  maxWidth: '100px',
                  flex: '0 0 100px',
                }}
              />
            )}
          />
        </Box>
        <Box sx={{ display: "flex", gap: 1 }}>
          <Controller
            name="serviceFacility.npi"
            control={control}
            render={({ field, fieldState }) => (
              <ClaimTextField
                field={field}
                fieldState={fieldState}
                size="small"
                placeholder="a. NPI"
                sx={formStyles.monospaceField}
              />
            )}
          />
        </Box>
      </Box>
    </>
  );
};
